/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
      return value.toString().padStart(2, '0')
    })
    return time_str
  }
  //图片地址
  export function getImageUrl(rtype) {
      var url = "http://old.xinsec.com.cn";
      if(rtype == 2){
        //产品和解决方案
        url = "http://network-old.xinsec.com.cn";
      }else if(rtype == 3){
        //产品和解决方案
        url = "http://iot-old.xinsec.com.cn";
      }
      return url;
  }
  export function escape2Html(str,rtype) { 
    var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'}; 
    str = str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];}); 
    if(rtype == 2){
        str = str.replace(/\/static/g, "http://iot-old.xinsec.com.cn/static")
    }else if(rtype == 1){
      str = str.replace(/\/static/g, "http://old.xinsec.com.cn/static")
    }else{
      str = str.replace(/\/static/g, "http://network-old.xinsec.com.cn/static")
    }
    return str;
  }
  //时间戳转
  export function formatDate(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + MM + DD +" "+hh + mm + ss;
  }
  /**
   * @param {number} time
   * @param {string} option
   * @returns {string}
   */
  export function formatTime(time, option) {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    } else {
      time = +time
    }
    const d = new Date(time)
    const now = Date.now()
  
    const diff = (now - d) / 1000
  
    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
      return '1天前'
    }
    if (option) {
      return parseTime(time, option)
    } else {
      return (
        d.getMonth() +
        1 +
        '月' +
        d.getDate() +
        '日' +
        d.getHours() +
        '时' +
        d.getMinutes() +
        '分'
      )
    }
  }
  
  /**
   * @param {string} url
   * @returns {Object}
   */
  export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
          .replace(/\+/g, ' ') +
        '"}'
    )
  }
  //通用正则表达式
  export let reg = {
      not2float: /([0-9]+\.[0-9]{3})[0-9]*/,
      isNumber:/^ [0 - 9] +.? [0 - 9] * $ /,
      not1float: /^\d+(\.\d{1})?$/,
      notInt: /^[0-9]*$/,
      not2float: /^\d+(\.\d{2})?$/,
      float2:/^\d+(\.\d{0,2})?$/,
    int2:/^[0-9]*$/,
    phone:/^[1-9]+\d{10}$/,
    psw:/^[\u4E00-\u9FA5\uf900-\ufa2d\w]+$/,
    pswInt:/^\d+$/,
  }
  //合并对象
  export function merge(target, source) {
      let obj = {}
      for (let i in source) {
          obj[i] = source[i];
      }
      for (let j in target) {
          obj[j] = target[j];
      }
  
      return obj;
  }
  //浅拷贝对象
  export function copyObj (obj){
      let result = {}
      for (let i in obj) {
          result[i] = obj[i];
      }
      return result
  }
  export function checkPhone (phone){
    if(!(/^1\d{10}$/.test(phone))){  
      return false; 
    } 
    return true;
}


  


// WEBPACK FOOTER //
// ./src/utils/index.js